import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import {
  UiGridCommonService,
  ScriptLoaderService,
} from '@everymatrix-base-components/utils';

const scriptLoader = new ScriptLoaderService('modules');
const module = 'ui-grid-bridge';
const report = 'everymatrix-mm-verification-report';

scriptLoader
  .loadAngularJsAndUiGridIfNeeded()
  .then(() => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .then(() => {
        const element = document.querySelector(report)!;
        const shadowRoot = element.shadowRoot!;
        const target = shadowRoot.querySelector(`.${report}`)!;

        if (!UiGridCommonService.getAngularJsMainModuleName()) {
          if (!UiGridCommonService.isAngularjsModuleDefined(module)) {
            UiGridCommonService.initAngularjsApp(module);
          }

          if (!UiGridCommonService.isElementBootstrapped(target)) {
            UiGridCommonService.bootstrapAngularjsApp(target, module);
          }
        } else {
          UiGridCommonService.compileAngularjsApp(target);
        }
      });
  })
  .catch((err) => console.error(err));
